module.exports = new __parcel__URL__("tide-fc.9e473584.png").toString();